import { api } from "@/lib/api";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function loadGoogleAnalytics() {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args) { window.dataLayer.push(args); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function trackEvent(eventType, { path, metadata } = {}) {
  if (window.gtag) {
    window.gtag("event", eventType, metadata || {});
  }
  api.post("/analytics/track", { event_type: eventType, path, metadata }).catch(() => {});
}

export function trackPageview(path) {
  if (window.gtag && GA_ID) {
    window.gtag("config", GA_ID, { page_path: path });
  }
  trackEvent("pageview", { path });
}
